<script>
	import { onMount, afterUpdate } from 'svelte';
	// import bbidata from '../bbidata.json';
	import { getData } from '@general/myAxios';
	// import _ from 'lodash';
	import Input from '@general/myInput.svelte';
	// export let name;

	let selTimeline, options = [], timelines = []

	onMount(() => {
		getData('/list').then(result => {
			timelines = result.data.map(res => composeJson(res))
			// console.log('@ timelines ', timelines)
		})
	})

	afterUpdate(() => {
		//TODO: deprecate this
		// if (selTimeline == '0')
		// 	new TL.Timeline('timeline-div', bbidata)

		if (!selTimeline && timelines.length > 0){
			selTimeline = timelines.find(t => t.is_highlighted)?.uuid ?? timelines[0].uuid
		}

		if (selTimeline && timelines.length > 0) {
			let tlObj = timelines.find(t => t.uuid == selTimeline)
			// console.log(tlObj)
			new TL.Timeline('timeline-div', tlObj.tl)
		}
	});

	let composeJson = ({ title, uuid, is_highlighted, data, timelineimages }) => {
		//shift 1st element
		options = [...options, {
			text: title.toUpperCase(),
			value: uuid
		}]

		//assign url links
		let linkedData = data.map(obj => {
			// console.log('@ tl imgs', timelineimages.find(tl => tl.name == obj.media.url)?.image)
			let newmedia = { ...obj.media, url: obj.media.type == 'link' ? obj.media.url : timelineimages.find(tl => tl.name == obj.media.url)?.image }
			return { ...obj, media: { ...newmedia } }
		})

		let ttpg = linkedData.find(d => d.is_title_page)
		let { text, media } = ttpg ?? linkedData.shift();
		let titleObj = { title: { text, media } }
		let eventObj = { events: [...linkedData.filter(d => !d.is_title_page)] }

		return {
			title, uuid, is_highlighted, tl: { ...titleObj, ...eventObj }
		}

	}


</script>

<main>
	<Input type='dropdown' tlClass={true} bind:selected={selTimeline} placeholder="Select Timeline..." {options} />
	<!-- {selTimeline}
	<hr /> -->

	<!-- <h1>{title}</h1> -->
	<div id='timeline-div' style="width: 100%; height: 600px;"></div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		/* max-width: 240px; */
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	/* .tl-attribution{
        display:none;
    } */
</style>